import { defineMessages } from 'react-intl';

export default defineMessages({
  noOptionSelectedMessage: {
    description: 'Automation Rules no option selected message',
    defaultMessage: 'Select one...',
    id: 'hBUy27',
  },
  chargeThirdPartyAccountLabel: {
    description: 'Automation Rules charge third part account label',
    defaultMessage: 'Account #',
    id: '1/4yGv',
  },
  chargeThirdPartyCountryLabel: {
    description: 'Automation Rules charge third part country label',
    defaultMessage: 'Billing Country',
    id: 'djX0eM',
  },
  chargeThirdPartyPostalCodeLabel: {
    description: 'Automation Rules charge third part postal code label',
    defaultMessage: 'Billing Zip',
    id: '0ylWB4',
  },
  unexpectedValueMessage: {
    description: 'Automation Rules unexpected value',
    defaultMessage: 'Unexpected value supplied to this action. Please contact support.',
    id: 'fqic1C',
  },
  payTypeAny: {
    description: 'Automation Rules COD pay type any',
    defaultMessage: 'Any',
    id: 'jjcY7l',
  },
  payTypeCash: {
    description: 'Automation Rules COD pay type cash',
    defaultMessage: 'Cash',
    id: 'D3/0Ea',
  },
  payTypeMoneyOrder: {
    description: 'Automation Rules COD pay type money order or cashiers check',
    defaultMessage: "Money Order / Cashier's Check",
    id: '7mliD8',
  },
  codPaymentType: {
    description: 'Automation Rules COD payment type ',
    defaultMessage: 'Payment Type',
    id: 'dZvvSX',
  },
  codPaymentAmount: {
    description: 'Automation Rules COD pay amount',
    defaultMessage: 'Amount',
    id: 'WUXt2S',
  },
  codPaymentUseOrderTotal: {
    description: 'Automation Rules COD - use Order total',
    defaultMessage: 'Use Order Total Amount',
    id: 'KbWZJt',
  },
  createAlertsExpireInDays: {
    description: 'Automation Rules COD - Create Alert expire in days',
    defaultMessage: 'Expire in {daysCount} days',
    id: '/FEaTI',
  },
  dangerousGoodsTypeOfGoods: {
    description: 'Automation Rules - Dangerous Good - Type of Goods',
    defaultMessage: 'Type of Goods',
    id: 'IOs+F+',
  },
  dangerousGoodsEmergencyContact: {
    description: 'Automation Rules - Dangerous Good - Emergency Contact',
    defaultMessage: 'Emergency Contact',
    id: 'ipImZB',
  },
  dangerousGoodsClassificationUnknown: {
    description: 'Automation Rules - Dangerous Good - Classification - Unknown',
    defaultMessage: 'Unknown',
    id: '0+o1ir',
  },
  shipFromLabel: {
    description: 'Automation Rules - Set Fulfillment Provider - Ship From ',
    defaultMessage: 'Ship From',
    id: 'agDPU+',
  },
  serviceLabel: {
    description: 'Automation Rules - Set Fulfillment Provider - Service ',
    defaultMessage: 'Service',
    id: '03LM5v',
  },
  autoSendLabel: {
    description: 'Automation Rules - Set Fulfillment Provider - Auto Send checkbox label ',
    defaultMessage: 'Automatically send fulfillment request to provider.',
    id: 'P772/o',
  },
  packageLabel: {
    description: 'Automation Rules - Set Carrier/Service/Package - Package',
    defaultMessage: 'Package',
    id: 'HaFBk5',
  },
  createAlertsExpiration: {
    description: 'Automation Rules - Create Alert - Expiration',
    defaultMessage: 'Expiration',
    id: '516Pa+',
  },
  sendEmailTemplate: {
    description: 'Automation Rules - Send Email - Template',
    defaultMessage: 'Template',
    id: 'EJ2t9i',
  },
  serviceCollection: {
    description: 'Automation Rules - serviceCollection',
    defaultMessage: 'Rate Shopper',
    id: 'DywYH5',
  },
  prepayDutiesAndTaxes: {
    description: 'Automation Rules - prepayDutiesAndTaxes',
    defaultMessage: 'Prepay Duties and Taxes',
    id: 'JmE9Wu',
  },
  setDaysAfterOrderDate: {
    defaultMessage: '<a></a> days after order date',
    description: 'automationRules.setShipBy',
    id: 'd0+E3X',
  },
  setContainsDangerousGoodsNameContact: {
    description: 'Automation Rules set contains dangerous goods name contact label',
    defaultMessage: 'Name Contact',
    id: 'VzLUSa',
  },
  setContainsDangerousGoodsPhoneContact: {
    description: 'Automation Rules set contains dangerous goods phone contact label',
    defaultMessage: 'Phone Contact',
    id: 'itZk5L',
  },
  holdIndefinitely: {
    description: 'Automation Rules - Hold Order For - Indefinitely checkbox label',
    defaultMessage: 'Hold Indefinitely',
    id: 'CeqwWo',
  },
});
